module.exports = __webpack_public_path__ + "img/抖动特效--动态抖屏gif.e7978135.gif";